import play from "../../images/testimonials/play.svg";

const VideoGrid = ({ videos, onVideoClick }) => {
  return (
    <div className="video-grid">
      <div className="container">
        <h2>Testimonials</h2>
        <div className="grid">
        {videos.map((video) => (
          <div
            key={video.id}
            className="video-card"
            onClick={() => onVideoClick(video.url)}
          >
            <div className="video-thumbnail-placeholder">
              <img
                // src={`https://img.youtube.com/vi/${video.url.split('v=')[1]}/hqdefault.jpg`}
                src={video.img}
                alt={video.title}
                className="thumbnail-image"
              />
              <div className="play-icon">
                <img src={play} alt="Play Icon" />
              </div>
            </div>
            <p>{video.title}</p>
          </div>
        ))}
      </div></div>
    </div>
  );
};

export default VideoGrid;
